export default __webpack_public_path__ + "static/media/infoerror.f7058bb5.svg";